// 3_pages/brand_page.js
// Natios brand page: clones the header category menu into the #natios-categories
// section (without its 3rd-level submenus) and wires the down-arrow to scroll to
// the second section.

export function init() {
	/* 	if (!document.body.classList.contains("in-o-znacce-natios")) return; */
	if (
		!document.body.classList.contains("in-o-znacce-natios") &&
		!document.body.classList.contains("in-o-znacke-natios")
	)
		return;

	copyCategoriesToBrandPage();
}

function copyCategoriesToBrandPage() {
	const categoriesSection = document.querySelector("#natios-categories");
	const categoryFromHeader = document.querySelectorAll("#header .menu-level-2");
	if (!categoriesSection || !categoryFromHeader || categoryFromHeader.length === 0) {
		return;
	}

	const categoryCopy = categoryFromHeader[0].cloneNode(true);
	categoriesSection.appendChild(categoryCopy);
	const menusLevelThree = categoryCopy.querySelectorAll(".menu-level-3");
	if (!menusLevelThree || menusLevelThree.length === 0) {
		return;
	}
	menusLevelThree.forEach((ul) => {
		ul.remove();
	});

	const arrowSectionDown = document.querySelector(".arrow-section-down");
	if (arrowSectionDown) {
		const secondSection = document.querySelector(".brand-page .full-width-wrapper:nth-of-type(2)");
		if (secondSection) {
			arrowSectionDown.addEventListener("click", () => {
				secondSection.scrollIntoView({ behavior: "smooth" });
			});
		}
	}
}
